import React, { useEffect, useState } from 'react'
import { IGallery } from '../../../models/Gallery'

const WSPGallery: React.FC<{ galleryImages: IGallery }> = ({ galleryImages }) => {
  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const imagesCount = galleryImages.gallery.length

  const handleOpenModal = (index: number) => {
    setSlideNumber(index)
    setOpenModal(true)
  }

  // Close Modal
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  // Previous Image
  const prevSlide = () => {
    slideNumber === 0
        ? setSlideNumber(galleryImages.gallery.length - 1)
        : setSlideNumber(slideNumber - 1)
  }

  // Next Image
  const nextSlide = () => {
    slideNumber + 1 === galleryImages.gallery.length
        ? setSlideNumber(0)
        : setSlideNumber(slideNumber + 1)
  }

  // keyboard support while the slider is open - in RTL the left arrow moves forward
  useEffect(() => {
    if (!openModal) return

    const onKeyDown = (ev: KeyboardEvent) => {
      if (ev.key === 'Escape') setOpenModal(false)
      if (ev.key === 'ArrowLeft') setSlideNumber(number => (number + 1) % imagesCount)
      if (ev.key === 'ArrowRight') setSlideNumber(number => (number - 1 + imagesCount) % imagesCount)
    }
    document.body.classList.add('lightbox-open')
    window.addEventListener('keydown', onKeyDown)
    return () => {
      document.body.classList.remove('lightbox-open')
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [openModal, imagesCount])

  return (
      <div>
        {openModal &&
            <div className='sliderWrap'>
              <button type="button" className="material-icons btnClose" aria-label="סגירה" onClick={handleCloseModal}>
                close
              </button>
              <button type="button" className="material-icons btnNext" aria-label="התמונה הקודמת" onClick={prevSlide}>
                navigate_next
              </button>
              <button type="button" className="material-icons btnPrev" aria-label="התמונה הבאה" onClick={nextSlide}>
                navigate_before
              </button>

              <div className='fullScreenImage'>
                <img key={slideNumber} src={galleryImages.gallery[slideNumber].original} alt='' />
              </div>
              <div className="slider-counter" dir="ltr">{slideNumber + 1} / {imagesCount}</div>
            </div>
        }

        <div className='galleryWrap'>
          {
              galleryImages && galleryImages.gallery.map((slide, index: number) => {
                return (
                    <button
                        type="button"
                        className='single'
                        key={index}
                        onClick={() => handleOpenModal(index)}
                    >
                      <img src={slide.thumbnail} alt='' loading="lazy" />
                    </button>
                )
              })
          }
        </div>
      </div>
  )
}

export default WSPGallery
